import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@UI/Button/Button";
import { PageContent } from "@UI/PageContent/PageContent";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageContent title="404">
      <section aria-labelledby="not-found-title">
        <p id="not-found-title">{t("notFound.page", "გვერდი ვერ მოიძებნა")}</p>
        <Button
          label={t("notFound.backHome", "მთავარზე დაბრუნება")}
          size="lg"
          variant="primary"
          onClick={() => navigate("/")}
        />
      </section>
    </PageContent>
  );
};

export default NotFound;
